(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["perf-product-buy-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('perf-buy-bar')) {
    class PerfBuyBar extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.timers = [];
        this.submitting = false;
        const signal = this.controller.signal;

        this.form = this.querySelector('form');
        this.variantInput = this.querySelector('[data-variant-id]');
        this.qtyInput = this.querySelector('[data-qty-input]');
        this.addButton = this.querySelector('[data-add]');
        this.addText = this.querySelector('[data-add-text]');
        this.variants = this.parseVariants();

        if (!this.form || !this.variantInput || !this.qtyInput) return;

        // Quantity controls (respect min / max / increment)
        this.querySelector('[data-qty-minus]')?.addEventListener(
          'click',
          () => this.setQty(this.currentQty() - this.step()),
          { signal }
        );
        this.querySelector('[data-qty-plus]')?.addEventListener(
          'click',
          () => this.setQty(this.currentQty() + this.step()),
          { signal }
        );
        this.qtyInput.addEventListener('change', () => this.setQty(this.currentQty()), { signal });

        // Double-submit guard (native form POST is kept)
        this.form.addEventListener(
          'submit',
          (event) => {
            if (this.submitting) {
              event.preventDefault();
              return;
            }
            this.setQty(this.currentQty());
            this.submitting = true;
            this.addButton?.setAttribute('aria-busy', 'true');
          },
          { signal }
        );
        window.addEventListener(
          'pageshow',
          () => {
            this.submitting = false;
            this.addButton?.removeAttribute('aria-busy');
          },
          { signal }
        );

        // Variant sync: theme event first, then URL / external id input fallback
        const onThemeVariant = (event) => {
          const id = event.detail?.resource?.id ?? event.detail?.variant?.id;
          if (id) this.applyVariant(id);
          else this.scheduleSync();
        };
        document.addEventListener('variant:update', onThemeVariant, { signal });
        document.addEventListener('variant:change', onThemeVariant, { signal });

        document.addEventListener(
          'change',
          (event) => {
            const target = event.target;
            if (!(target instanceof Element) || this.contains(target)) return;
            if (target.matches('select, input[type="radio"], input[name="id"]')) this.scheduleSync();
          },
          { signal }
        );
        window.addEventListener('popstate', () => this.syncFromTheme(), { signal });

        // Mobile sticky offset so the bar never covers page content
        if (this.dataset.sticky === 'true') {
          document.body.classList.add('perf-buybar-sticky-active');
          document.documentElement.style.setProperty(
            '--perf-buybar-offset',
            `${parseInt(this.dataset.stickyOffset, 10) || 0}px`
          );
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.timers.forEach(clearTimeout);
        this.timers = [];
        if (this.dataset.sticky === 'true') {
          document.body.classList.remove('perf-buybar-sticky-active');
          document.documentElement.style.removeProperty('--perf-buybar-offset');
        }
      }

      parseVariants() {
        try {
          const raw = this.querySelector('script[data-perf-variants]')?.textContent || '[]';
          const data = JSON.parse(raw);
          return Array.isArray(data) ? data : [];
        } catch (error) {
          return [];
        }
      }

      findVariant(id) {
        return this.variants.find((variant) => String(variant.id) === String(id));
      }

      // Quantity helpers
      minQty() { return parseInt(this.qtyInput.min, 10) || 1; }
      maxQty() { const max = parseInt(this.qtyInput.max, 10); return Number.isFinite(max) ? max : Infinity; }
      step() { return parseInt(this.qtyInput.step, 10) || 1; }
      currentQty() { const value = parseInt(this.qtyInput.value, 10); return Number.isFinite(value) ? value : this.minQty(); }

      setQty(value) {
        const min = this.minQty();
        const max = this.maxQty();
        const step = this.step();
        let next = Math.max(min, Math.min(max, value));
        next = min + Math.round((next - min) / step) * step;
        if (next > max) next -= step;
        this.qtyInput.value = Math.max(min, next);
      }

      // Variant sync
      scheduleSync() {
        this.timers.forEach(clearTimeout);
        // Themes update the URL after an async section fetch, so re-check a couple of times.
        this.timers = [150, 600].map((delay) => setTimeout(() => this.syncFromTheme(), delay));
      }

      readThemeVariantId() {
        const fromUrl = new URLSearchParams(window.location.search).get('variant');
        if (fromUrl && this.findVariant(fromUrl)) return fromUrl;

        for (const input of document.querySelectorAll('form[action*="/cart/add"] [name="id"]')) {
          if (this.contains(input)) continue;
          if (input.value && this.findVariant(input.value)) return input.value;
        }
        return null;
      }

      syncFromTheme() {
        const id = this.readThemeVariantId();
        if (id) this.applyVariant(id);
      }

      applyVariant(id) {
        const variant = this.findVariant(id);
        if (!variant) return;

        this.variantInput.value = variant.id;

        // Quantity rules can differ per variant (B2B / Markets)
        this.qtyInput.min = variant.min || 1;
        this.qtyInput.step = variant.step || 1;
        if (variant.max) this.qtyInput.max = variant.max;
        else this.qtyInput.removeAttribute('max');
        this.setQty(this.currentQty());

        if (this.addButton && this.addText) {
          this.addButton.disabled = !variant.available;
          this.addText.textContent = variant.available
            ? this.dataset.addText
            : this.dataset.soldOutText;
        }
      }
    }

    customElements.define('perf-buy-bar', PerfBuyBar);
  }
  } catch(e) { console.error(e); }
})();

})();
